"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaTransactionToJSON = exports.RosettaTransactionFromJSONTyped = exports.RosettaTransactionFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaTransactionFromJSON(json) {
    return RosettaTransactionFromJSONTyped(json, false);
}
exports.RosettaTransactionFromJSON = RosettaTransactionFromJSON;
function RosettaTransactionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transaction_identifier': _1.TransactionIdentifierFromJSON(json['transaction_identifier']),
        'operations': (json['operations'].map(_1.RosettaOperationFromJSON)),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.RosettaBlockMetadataFromJSON(json['metadata']),
    };
}
exports.RosettaTransactionFromJSONTyped = RosettaTransactionFromJSONTyped;
function RosettaTransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transaction_identifier': _1.TransactionIdentifierToJSON(value.transaction_identifier),
        'operations': (value.operations.map(_1.RosettaOperationToJSON)),
        'metadata': _1.RosettaBlockMetadataToJSON(value.metadata),
    };
}
exports.RosettaTransactionToJSON = RosettaTransactionToJSON;
//# sourceMappingURL=RosettaTransaction.js.map